import React, { useState, useEffect } from 'react';
import './Order.css'; // Import combined CSS
import { Header } from "../Header";
import Modal from './Modal'; // Import the Modal component
import { CircularProgress, Button } from '@mui/material'; // Import CircularProgress and Button
import { local_url } from '../Const';

const API_URL = `${local_url}/api/Customer/L111/FS/00001/`;

const buttonColors = [
  '#7fb3d5', '#f0b27a', '#e57373', '#a3d99b',
  '#d7a6e0', '#ffb74d', '#64b5f6', '#ba68c8'
];

export const Order = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(API_URL);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setCustomers(data.branches || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const handleCustomerPress = (customerName) => {
    setSelectedCustomer(customerName);
    setIsModalOpen(true);
  };

  const handleSaleOrder = () => {
    alert(`Sale Order for: ${selectedCustomer}`);
    setIsModalOpen(false);
  };

  const handleSaleReturn = () => {
    alert(`Sale Return for: ${selectedCustomer}`);
    setIsModalOpen(false);
  };

  const sortedCustomers = [...customers].sort((a, b) =>
    a.customerName.localeCompare(b.customerName)
  );

  return (
    <>
      <Header />
      <div className="order-list-header"></div>

      {loading ? (
        <div className="loader-container">
          <CircularProgress />
          <h2>Loading Customers...</h2>
        </div>
      ) : error ? (
        <div className="error-message">
          <h2>Error fetching customers</h2>
          <p>{error}</p>
          <Button onClick={fetchCustomers} variant="contained">Retry</Button>
        </div>
      ) : (
        <div className="customer-box">
          <div className="customer-container">
            {sortedCustomers.map((customer, index) => (
              <button
                key={customer.customerCode}
                className="customer-button"
                style={{ backgroundColor: buttonColors[index % buttonColors.length] }}
                onClick={() => handleCustomerPress(customer.customerName)}
              >
                {customer.customerName}
              </button>
            ))}
          </div>
        </div>
      )}

      <Modal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSaleOrder={handleSaleOrder} 
        onSaleReturn={handleSaleReturn}
      />
    </>
  );
};

export default Order;
